export enum SatisfactionSurveyFrequencyType {
  ALWAYS = 'ALWAYS',
  ORDER_COLLECTION = 'ORDER_COLLECTION',
  LAST_DAYS = 'LAST_DAYS',
}
